import React, { Component } from "react";

import { Spin } from "antd";
import FormReddition from "../../components/FormReddition";
import { connect } from "react-redux";
import { loadEcritures, saveEcriture, updateEcritures } from "../../store/actions/ecritureAction";
import { incrementSocieteInvoiceCounter } from "../../store/actions/societeAction";
import { loadJournals } from "../../store/actions/journalAction";
import { loadLocations } from "../../store/actions/locationAction";
import { loadProprietaires } from "../../store/actions/proprietaireAction";
import { loadLots } from "../../store/actions/lotAction";
import { loadQuittances } from "../../store/actions/quittanceAction";
import { loadReglements, updateReglements } from "../../store/actions/reglementAction";
import { saveEmail } from "../../store/actions/emailAction";
import { saveDossier } from "../../store/actions/dossierAction";
import { saveDocument } from "../../store/actions/documentAction";
import { updateProprietaireAffectation } from "../../store/actions/proprietaireAffectationAction";
import { TYPE_TAG } from "../../utils/constants";

class Reddition extends Component {
  componentDidMount() {
    Promise.all([
      !this.props.journals && this.props.loadJournals(),
      !this.props.locations && this.props.loadLocations(),
      !this.props.proprietaires && this.props.loadProprietaires(),
      !this.props.quittances && this.props.loadQuittances(),
      !this.props.reglements && this.props.loadReglements(),
      !this.props.ecritures && this.props.loadEcritures(),
      !this.props.lots && this.props.loadLots(),
    ]);
  }

  render() {
    const {
      utilisateur,
      parametre,
      journals,
      locations,
      proprietaires,
      quittances,
      reglements,
      ecritures,
      report,
      tags,
      lots
    } = this.props;

    return (
      <Spin
        size="large"
        tip="Chargement en cours..."
        spinning={!proprietaires || !locations || !quittances || !reglements || !ecritures}
      >
        <FormReddition
          utilisateur={utilisateur}
          parametre={parametre}
          journals={journals}
          lots={lots}
          locations={
            locations &&
            locations.filter((l) => l.location_etat === "r")
          }
          proprietaires={
            proprietaires &&
            proprietaires.filter(
              (p) =>
                p.proprietaire_affectations.some(
                  (ligne) =>
                    ligne.proprietaire_affectation_societe.societe_id === utilisateur.societe_id
                ) && p.proprietaire_personne.personne_actif === true
            )
          }
          quittances={quittances}
          reglements={reglements}
          ecritures={ecritures}
          report={report}
          tags={tags
            .filter((tag) => tag.tag_type === TYPE_TAG[0].value)
            .sort((a, b) => a.tag_ordre - b.tag_ordre)}
          saveEcriture={this.props.saveEcriture}
          updateEcritures={this.props.updateEcritures}
          updateReglements={this.props.updateReglements}
          saveEmail={this.props.saveEmail}
          saveDossier={this.props.saveDossier}
          saveDocument={this.props.saveDocument}
          updateProprietaireAffectation={this.props.updateProprietaireAffectation}
          incrementInvoiceCounter={this.props.incrementInvoiceCounter}
          addPanesPersonne={this.props.addPanesPersonne}
        />
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadJournals: () => dispatch(loadJournals()),
    loadLocations: () => dispatch(loadLocations()),
    loadProprietaires: () => dispatch(loadProprietaires()),
    loadLots: () => dispatch(loadLots()),
    loadQuittances: () => dispatch(loadQuittances()),
    loadReglements: () => dispatch(loadReglements()),
    loadEcritures: () => dispatch(loadEcritures()),
    saveEcriture: (ecriture) => dispatch(saveEcriture(ecriture)),
    updateEcritures: (jsonData) => dispatch(updateEcritures(jsonData)),
    updateReglements: (jsonData) => dispatch(updateReglements(jsonData)),
    saveEmail: (jsonData) => dispatch(saveEmail(jsonData)),
    saveDossier: (jsonData) => dispatch(saveDossier(jsonData)),
    saveDocument: (jsonData, dossier, tag) => dispatch(saveDocument(jsonData, dossier, tag)),
    updateProprietaireAffectation: (jsonData, proprietaire_id, societe_id) =>
      dispatch(updateProprietaireAffectation(jsonData, proprietaire_id, societe_id)),
    incrementInvoiceCounter: (invoice_counter) =>
      dispatch(incrementSocieteInvoiceCounter(invoice_counter)),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    parametre: state.parametre.data,
    journals: state.journals.data,
    locations: state.locations.data,
    proprietaires: state.proprietaires.data,
    lots: state.lots.data,
    quittances: state.quittances.data,
    reglements: state.reglements.data,
    ecritures: state.ecritures.data,
    report: state.ecritures.report,
    tags: state.tags.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Reddition);
